import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import ErrorPage from 'app/components/ErrorPage';
import { trackCatalogExplore } from 'app/actions/AnalyticsGa4Actions';
import { METADATA_CATEGORY_TYPE } from 'app/constants/AnalyticsGa4Constants';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import { selectRecommendations } from 'app/selectors/bibs/RecommendationsSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { DocumentHeadContainer } from 'app/components/shared/DocumentHead';
import AllRecommendationsPage from './AllRecommendationsPage';

const AllRecommendationsPageContainer = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const catalogBib = useSelector(selectCatalogBib);
  const recommendations = useSelector(selectRecommendations);

  if (!recommendations) {
    return <ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />;
  }

  const title = catalogBib.getIn(['brief', 'title']);
  const pageTitle = intl.formatMessage({ id: 'recommendations_page_title' }, { title });

  const handleAuthorClick = linkText => {
    dispatch(
      trackCatalogExplore({
        bibId: catalogBib.get('metadataId'),
        metadata: {
          metadata_category_type: METADATA_CATEGORY_TYPE.BIBLIOGRAPHIC_DETAILS_CREATORS,
          metadata_value: linkText
        },
        ui: {
          ui_component_label: linkText,
          ui_component_type: 'link-text'
        }
      })
    );
  };

  return (
    <div>
      <DocumentHeadContainer pageTitle={pageTitle} />
      <AllRecommendationsPage
        catalogBib={catalogBib}
        recommendations={recommendations}
        handleAuthorClick={handleAuthorClick}
      />
    </div>
  );
};

export default AllRecommendationsPageContainer;
